<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="dialog-form">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4 windeGridTitle>
            <span class="font-weight-normal">{{ 'customer.home.companyLocations.title' | translate }}</span>
            <winde-ctx-sensitive-help placement="right" tooltipTextPath="customers.location.btn.create">
                <button (click)="addNewLocation()" windeActionIcon>
                    <sui-svg-icon icon="plus-circle" windeGreen />
                </button>
            </winde-ctx-sensitive-help>
        </h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>
    <div class="siklu-mat-dialog-body" matDialogContent>
        <div class="locations">
            <div class="locations__list">
                <winde-sui-tabs
                    (activeTabChange)="selectLocation($event)"
                    [activeTab]="activeLocation"
                    [tabsList]="locations()"
                ></winde-sui-tabs>
            </div>

            <div class="locations__info">
                <winde-alert-error></winde-alert-error>

                @if (editMode) {
                    <div class="new-location">
                        <div class="form-group new-location__inp">
                            <span>Location name</span>
                            <sui-string-component [config]="activeLocation.content.name"></sui-string-component>
                        </div>
                        <div class="form-group new-location__inp new-location__inp--currency">
                            <span>Currency</span>
                            <sui-select-component [config]="currencySelect"></sui-select-component>
                        </div>
                        <div class="new-location__btns">
                            <button (click)="saveLocation()" windeGreen>
                                <sui-svg-icon icon="save" />
                                {{ 'entity.action.save' | translate }}
                            </button>
                            <button (click)="discardChanges()" windeTransparent>
                                <sui-svg-icon icon="cross" />
                                {{ 'entity.action.cancel' | translate }}
                            </button>
                        </div>
                    </div>
                } @else {
                    <div class="selected-location">
                        @if (locationExtended) {
                            <div class="selected-location__header">
                                <h5>
                                    <winde-ctx-sensitive-help [tooltipText]="locationExtended.name">
                                        <span class="selected-location__name">{{ locationExtended.name }}</span>
                                    </winde-ctx-sensitive-help>
                                    @if (activeLocation.content.currency) {
                                        <span class="d-inline-block align-middle">
                                            ({{ customerLocationService.getCurrencySymbolByCode(activeLocation.content.currency) }})
                                        </span>
                                    }
                                </h5>
                                <div class="align-horizontally">
                                    <winde-ctx-sensitive-help class="mx-1" placement="bottom" tooltipTextPath="customers.location.btn.edit">
                                        <button (click)="openEditLocation()" windeTransparent>
                                            <sui-svg-icon icon="pencil" windeOrange />
                                        </button>
                                    </winde-ctx-sensitive-help>
                                    @if (locationExtended.customersCount === 0) {
                                        <winde-ctx-sensitive-help
                                            class="mx-1"
                                            placement="bottom"
                                            tooltipTextPath="customers.location.btn.remove"
                                        >
                                            <button (click)="showDeleteConfirmation = true" windeTransparent>
                                                <sui-svg-icon icon="cross" windeRed />
                                            </button>
                                        </winde-ctx-sensitive-help>
                                    }
                                </div>
                            </div>
                        }

                        <div class="selected-location__alerts mt-2">
                            @if (showDeleteConfirmation) {
                                <div class="selected-location__delete-warning alert alert-warning">
                                    <div class="py-3">
                                        Are you sure you want to delete Location
                                        <span class="selected-location__delete-name"> {{ locationExtended.name }} </span>?
                                    </div>
                                    <div>
                                        <div class="text-center">
                                            <button (click)="deleteLocation()" windeRed>
                                                <sui-svg-icon icon="trash" />
                                                {{ 'entity.action.delete' | translate }}
                                            </button>
                                            <button (click)="showDeleteConfirmation = false" windeTransparent>
                                                <sui-svg-icon icon="cross" />
                                                {{ 'entity.action.cancel' | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        @if (locationExtended) {
                            <div class="grid">
                                <!-- HEADER -->
                                <div class="grid-row">
                                    <div class="grid-row__cell">{{ 'customer.home.companyLocations.grid.usedIn' | translate }}</div>
                                    <div class="grid-row__cell">{{ 'customer.home.companyLocations.grid.quantity' | translate }}</div>
                                </div>

                                <!-- BODY -->
                                <div class="grid-row">
                                    <div class="grid-row__cell">{{ 'customer.home.companyLocations.grid.customers' | translate }}</div>
                                    <div class="grid-row__cell">{{ locationExtended.customersCount }}</div>
                                </div>
                                <div class="grid-row">
                                    <div class="grid-row__cell">{{ 'customer.home.companyLocations.grid.products' | translate }}</div>
                                    <div class="grid-row__cell">{{ locationExtended.productsCount }}</div>
                                </div>
                                <div class="grid-row">
                                    <div class="grid-row__cell">{{ 'customer.home.companyLocations.grid.accessor' | translate }}</div>
                                    <div class="grid-row__cell">{{ locationExtended.accessoriesCount }}</div>
                                </div>
                                <div class="grid-row">
                                    <div class="grid-row__cell">{{ 'customer.home.companyLocations.grid.services' | translate }}</div>
                                    <div class="grid-row__cell">{{ locationExtended.servicesCount }}</div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>
